export default __webpack_public_path__ + "static/media/ic_pilly_no_shopping.e383b163.svg";